/**
 * Ensure auth keys can be written even when hotelDetCard* filled localStorage.
 */

const AUTH_KEYS = new Set(["accessToken", "sytUserSession", "sytAccessList"]);

function isDisposableStorageKey(key) {
  if (!key || AUTH_KEYS.has(key)) return false;
  return (
    key.startsWith("hotelDetCard:") ||
    key.startsWith("hotelDetCard") ||
    key.startsWith("flightPersist") ||
    key.startsWith("busPersist") ||
    key.startsWith("combinedPersist")
  );
}

/** Remove bulky cache keys so auth token can be saved. */
export function pruneLocalStorageForAuth() {
  try {
    const keys = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const k = localStorage.key(i);
      if (k && isDisposableStorageKey(k)) keys.push(k);
    }
    keys.forEach((k) => {
      try {
        localStorage.removeItem(k);
      } catch {
        /* ignore */
      }
    });
    return keys.length;
  } catch {
    return 0;
  }
}

/**
 * Write accessToken (and optional user session). Retries after pruning if quota full.
 * Returns true only if accessToken is readable from localStorage afterwards.
 */
export function forceSaveAccessToken(token, userDetails) {
  if (token == null || token === "") return false;
  const tokenPayload = JSON.stringify(token);

  const writeOnce = () => {
    localStorage.setItem("accessToken", tokenPayload);
    if (userDetails && typeof userDetails === "object") {
      try {
        localStorage.setItem(
          "sytUserSession",
          JSON.stringify({
            UserID: userDetails.UserID,
            Email: userDetails.Email,
            Mobile: userDetails.Mobile,
            FirstName: userDetails.FirstName,
            LastName: userDetails.LastName,
            AgencyName: userDetails.AgencyName,
            AgentID: userDetails.AgentID,
            Membership: userDetails.Membership,
            Services: userDetails.Services,
            Deposit: userDetails.Deposit,
            Hold: userDetails.Hold,
            Role: userDetails.Role,
            Status: userDetails.Status,
          }),
        );
      } catch {
        // session optional if still tight on space — token is enough for getUserByauthToken
      }
    }
    const raw = localStorage.getItem("accessToken");
    return Boolean(raw && raw !== "null" && raw !== "undefined");
  };

  try {
    if (writeOnce()) return true;
  } catch {
    /* QuotaExceededError etc. */
  }

  pruneLocalStorageForAuth();

  try {
    return writeOnce();
  } catch {
    return false;
  }
}
